import React from 'react';
import { InputAdornment, TextField, Tooltip } from '@mui/material';
import { FilterIcon } from '../../components/atoms/Icons';
var DefaultFilter = function (_a) {
    var columnDef = _a.columnDef, onFilterChanged = _a.onFilterChanged, forwardedRef = _a.forwardedRef;
    var _b = React.useState(), typing = _b[0], setTyping = _b[1];
    var _c = React.useState(''), value = _c[0], setValue = _c[1];
    React.useEffect(function () {
        setValue(columnDef.tableData.filterValue || '');
    }, [columnDef.tableData.filterValue]);
    return (React.createElement(TextField, { ref: forwardedRef, variant: "standard", style: columnDef.type === 'numeric' ? { float: 'right' } : { float: 'left' }, type: columnDef.type === 'numeric' ? 'number' : 'search', value: value || '', onChange: function (event) {
            if (event.target.value === '') {
                onFilterChanged(columnDef.tableData.id, '');
            }
            setValue(event.target.value);
        }, onCompositionStart: function () { return setTyping(true); }, onCompositionEnd: function () { return setTyping(false); }, onKeyDown: function (e) {
            if (e.key !== 'Enter' || typing)
                return;
            onFilterChanged(columnDef.tableData.id, value);
        }, inputProps: { 'aria-label': "filter data by ".concat(columnDef.title) }, InputProps: columnDef.hideFilterIcon
            ? undefined
            : {
                startAdornment: (React.createElement(InputAdornment, { position: "start" },
                    React.createElement(Tooltip, { title: 'filter' },
                        React.createElement(FilterIcon, null)))),
            } }));
};
export default DefaultFilter;
